import { ColProps } from 'antd';

export interface FilterItemProps extends Partial<ColProps> {
  alwaysOn?: boolean;
  label?: React.ReactNode;
  name: string;
  selected?: React.ReactNode;
  children: React.ReactNode;
  group?: string;
  hideSelected?: boolean;
}

const FilterItem: React.FC<FilterItemProps> = () => {
  return null;
};

export default FilterItem;
